import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import AxiosDB from '@/config/axios2';

const AuthContext = createContext(null);
const { sha256 } = require("js-sha256");

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    if (token) {
      AxiosDB.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchUser = async () => {
    try {
      const response = await AxiosDB.get(`/auth/me`);
      setUser(response.data);
    } catch (error) {
      console.error('Error fetching user:', error);
      // logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    let encryptedPassword = sha256(password).toString();

    const response = await AxiosDB.post(`/auth/login`, { username: email, encryptedPassword, type: 'login' });
    const { token, user } = response.data;

    localStorage.setItem('token', token);
    setToken(token);
    setUser(user);
    AxiosDB.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    return user;
  };

  const loginWithToken = async (authToken) => {
    const response = await AxiosDB.get(`${API}/auth/token/${authToken}`);
    const { token, user } = response.data;

    localStorage.setItem('token', token);
    setToken(token);
    setUser(user);
    AxiosDB.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    return user;
  };

  const register = async (email, password, nombre) => {
    const response = await AxiosDB.post(`${API}/auth/register`, { email, password, nombre });
    const { token, user } = response.data;

    localStorage.setItem('token', token);
    setToken(token);
    setUser(user);
    AxiosDB.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    return user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    delete AxiosDB.defaults.headers.common['Authorization'];
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginWithToken, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};